import React from 'react'
import HouseholdInfoNeeded from 'components/StraightThroughHouseholdComp/4_BlockPage/HouseholdInfoNeeded'
import HouseholdReturnHome from 'components/StraightThroughHouseholdComp/4_BlockPage/HouseholdReturnHome'

const BlockMain = () => {
  return (
    <>
      <HouseholdInfoNeeded/>
      <hr />
      <HouseholdReturnHome/>
    </>
  )
}

export default BlockMain